<template>
  <section class="bets-container relative">
    <add-bet-modal v-if="isOpenForm"
                   :userAddingOnAnotherPage="{isAdding: userAddingOnAnotherPage}"
                   :isBetDiscussion="isBetDiscussion"
                   :isAddBetDiscussionAllowed="isAddBetDiscussionAllowed"
                   @close="closeAddBetModal"
                   @end="() => { this.userAddingOnAnotherPage = false}"
                   @addbet="betAddedByUser">
    </add-bet-modal>
    <coupon-modal v-if="isCouponModalOpen"
                  :coupon="coupon"
                  @close="this.isCouponModalOpen = false">
    </coupon-modal>
    <bets-calendar></bets-calendar>
    <div class="flex w-full flex-wrap shrink-0 grow-0 gap-x-2 gap-y-4 px-2
                xl:gap-x-5 xl:px-0">
      <div class="basis-1/4 grow relative">
        <div class="flex w-full relative flex-nowrap items-center justify-center bg-zt-light-hover rounded-zt px-3
                    py-2 zt-hover border border-zt-light cursor-pointer"
                :class="[[selectedFilterCategoryCount !== 0 ? ['shadow-[0_0_0_2px_#E6E6E6]'] : [], {'!z-[1001]' : window.size.desktop && filteringMenuOpened}]]"
                @click.stop="toggleFilter()">
          <div class="mr-5 w-full font-medium flex flex-nowrap items-center space-x-2 text-sm text-center justify-center
                      xl:mr-0">
            <span>Filtrowanie</span>
            <div v-if="selectedFilterCategoryCount !== 0"
                class="bg-white text-zt-normal w-[18px] h-[18px] rounded-zt flex items-center justify-center">
              {{ selectedFilterCategoryCount }}
            </div>
          </div>
          <svg class="absolute right-3 top-1/2 -translate-y-1/2" width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.7148 14.7143V1" stroke="white" stroke-linecap="round" />
            <path d="M9 14.7143V1" stroke="white" stroke-linecap="round" />
            <path d="M3.28516 14.7143V1" stroke="white" stroke-linecap="round" />
            <path d="M1.00084 3.28613L5.57227 3.28613" stroke="white" stroke-linecap="round" />
            <path d="M6.71373 11.2861H11.2852" stroke="white" stroke-linecap="round" />
            <path d="M12.4286 7.85742H17" stroke="white" stroke-linecap="round" />
          </svg>
        </div>
        <BetFilterModal v-show="filteringMenuOpened"
                        :selectedFilterCategoryCount="selectedFilterCategoryCount"
                        :odds="odds"
                        :disciplineAllSelected="disciplineAllSelected"
                        :allBetsCount="allBetsCount"
                        :disciplines="disciplines"
                        :showOnlyFollowedUsers="showOnlyFollowedUsers"
                        :showOnlyNotPlayedYet="showOnlyNotPlayedYet"
                        @toggleOnlyFollowedUsers="toggleOnlyFollowedUsers"
                        @toggleOnlyNotPlayedYet="toggleOnlyNotPlayedYet"
                        @togglefilter="toggleFilter"
                        @clearfilters="clearFilters"
                        @filterbets="filterBets"
                        @togglediscipline="toggleDiscipline"
                        @calculatebetcountbycategory="calculateBetCountByCategory" />
      </div>
      <div class="basis-1/4 grow relative h-[37px]" v-click-outside="searchingClickOutside">
        <input type="search" placeholder="Wyszukaj..."
               class="text-sm h-full pl-3 pr-8"
               v-model="searchInput"
               @compositionupdate="compositionUpdate"
               @focus="searchInputFocus = true"
               @keydown="searchTimeout"
               @keydown.enter="confirmSearch"/>
        <svg v-if="searchInput.length === 0" @click.stop="confirmSearch"
             class="absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer fill-text" aria-hidden="true"
             role="img" width="16" height="16" viewBox="0 0 28 28">
          <path d="M31.715 28.953c0.381 0.381 0.381 0.999 0 1.381l-1.381 1.381c-0.382 0.381-1 0.381-1.381 0l-9.668-9.668c-0.105-0.105-0.175-0.229-0.222-0.361-1.983 1.449-4.418 2.314-7.063 2.314-6.627 0-12-5.373-12-12s5.373-12 12-12c6.627 0 12 5.373 12 12 0 2.645-0.865 5.080-2.314 7.063 0.132 0.047 0.256 0.116 0.361 0.222l9.668 9.668zM12 4c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8c0-4.418-3.582-8-8-8z"></path>
        </svg>
        <svg v-else @click.stop="closeSearch" class="absolute right-0 bottom-[8px] cursor-pointer fill-text mr-2 mt-1" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.752537 11.6873C0.694959 11.6877 0.637882 11.6766 0.584578 11.6549C0.531274 11.6331 0.482792 11.601 0.441912 11.5605C0.400906 11.5198 0.368358 11.4714 0.346147 11.4181C0.323935 11.3648 0.3125 11.3076 0.3125 11.2498C0.3125 11.1921 0.323935 11.1349 0.346147 11.0816C0.368358 11.0283 0.400906 10.9799 0.441912 10.9392L10.9419 0.439212C11.0243 0.356829 11.136 0.310547 11.2525 0.310547C11.369 0.310547 11.4808 0.356829 11.5632 0.439212C11.6455 0.521595 11.6918 0.63333 11.6918 0.749837C11.6918 0.866344 11.6455 0.978079 11.5632 1.06046L1.06316 11.5605C1.02228 11.601 0.9738 11.6331 0.920496 11.6549C0.867192 11.6766 0.810115 11.6877 0.752537 11.6873Z" fill="white"/>
          <path d="M11.2518 11.6873C11.1942 11.6877 11.1371 11.6766 11.0838 11.6549C11.0305 11.6331 10.982 11.601 10.9412 11.5605L0.441165 1.06046C0.358782 0.978079 0.3125 0.866344 0.3125 0.749837C0.3125 0.63333 0.358782 0.521595 0.441165 0.439212C0.523548 0.356829 0.635283 0.310547 0.75179 0.310547C0.868297 0.310547 0.980032 0.356829 1.06242 0.439212L11.5624 10.9392C11.6034 10.9799 11.636 11.0283 11.6582 11.0816C11.6804 11.1349 11.6918 11.1921 11.6918 11.2498C11.6918 11.3076 11.6804 11.3648 11.6582 11.4181C11.636 11.4714 11.6034 11.5198 11.5624 11.5605C11.5215 11.601 11.4731 11.6331 11.4197 11.6549C11.3664 11.6766 11.3094 11.6877 11.2518 11.6873Z" fill="white"/>
        </svg>
      </div>
      <button v-if="isLoggedIn()"
              class="basis-full zt-button no-wrap overflow-hidden text-ellipsis  flex flex-nowrap items-center bg-zt-red py-2 rounded-zt justify-center"
              :class="[isAddBetAllowed ? '' : ['!bg-[#666666]', 'opacity-70', 'disabled', 'pointer-events-none']]"
              @click="openAddBetModal(false)">
        <span v-if="isAddBetAllowed" class="mr-3 uppercase">Dodaj typ</span>
        <span v-else class="uppercase mx-auto no-wrap overflow-hidden text-ellipsis">Nie można już dodawać typów na ten dzień</span>
        <svg v-if="isAddBetAllowed" width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.75 15.3945C9.75 15.6707 9.97386 15.8945 10.25 15.8945C10.5261 15.8945 10.75 15.6707 10.75 15.3945H9.75ZM10.75 5.27734C10.75 5.0012 10.5261 4.77734 10.25 4.77734C9.97386 4.77734 9.75 5.0012 9.75 5.27734H10.75ZM10.75 15.3945V5.27734H9.75V15.3945H10.75Z" fill="white"/>
          <path d="M5.19141 9.83594C4.91526 9.83594 4.69141 10.0598 4.69141 10.3359C4.69141 10.6121 4.91526 10.8359 5.19141 10.8359L5.19141 9.83594ZM15.3086 10.8359C15.5847 10.8359 15.8086 10.6121 15.8086 10.3359C15.8086 10.0598 15.5847 9.83594 15.3086 9.83594V10.8359ZM5.19141 10.8359L15.3086 10.8359V9.83594L5.19141 9.83594L5.19141 10.8359Z" fill="white"/>
          <rect x="0.75" y="0.835938" width="19" height="19" rx="2.5" stroke="white"/>
        </svg>
      </button>
      <div v-else
           class="basis-full flex flex-nowrap items-center bg-zt-main py-2 rounded-zt justify-center cursor-pointer
                  border-zt-light border-[1px] zt-hover" @click="openLoginModal">
        <span class="mr-3 uppercase">Zaloguj się, aby dodać typ</span>
        <svg width="20" height="20" viewBox="4 2 20 20">
          <path d="M13.293 7.293c-0.391 0.391-0.391 1.023 0 1.414l2.293 2.293h-7.586c-0.552 0-1 0.448-1 1s0.448 1 1 1h7.586l-2.293 2.293c-0.391 0.391-0.391 1.023 0 1.414 0.195 0.195 0.451 0.293 0.707 0.293s0.512-0.098 0.707-0.293l4.707-4.707-4.707-4.707c-0.391-0.391-1.023-0.391-1.414 0z" fill="white"></path>
        </svg>
      </div>

      <div v-if="userCanModerate && window.size.mobile" class="basis-full flex gap-x-2">
        <div @click="window.open('/wp-admin/edit-comments.php?comment_status=moderated', '_blank')"
             class="bg-zt-red/20 border border-zt-red rounded-zt flex justify-between items-center px-1 basis-1/2
                  h-[30px] cursor-pointer"
             :class="{ '!border-zt-more !bg-zt-more/20': WP.commentsToApproveCount === 0 }">
          <span class="text-sm">Komentarze</span>
          <div class="bg-zt-red rounded-zt w-[18px] h-[18px] font-semibold flex justify-center items-center shrink-0"
               :class="{ '!bg-zt-more': WP.commentsToApproveCount === 0 }">
            {{ Math.min(WP.commentsToApproveCount, 9) }}
          </div>
        </div>
        <div @click="window.open('/panel-admina/#zgloszenia', '_blank')"
             class="bg-zt-red/20 border border-zt-red rounded-zt flex justify-between items-center px-1 basis-1/2
                  h-[30px] cursor-pointer"
             :class="{ '!border-zt-more !bg-zt-more/20': WP.reportCount === 0 }">
          <span class="text-sm">Zgłoszenia</span>
          <div class="bg-zt-red rounded-zt w-[18px] h-[18px] font-semibold flex justify-center items-center shrink-0"
               :class="{ '!bg-zt-more': WP.reportCount === 0 }">
            {{ Math.min(WP.reportCount, 9) }}
          </div>
        </div>
      </div>

      <div class="basis-full mx-2 flex items-center justify-end border-b-[2px] border-zt-normal pb-1 xl:mx-0">
        <div class="text-[14px] font-normal text-white/50">
          Dodano typów:
          <span v-show="!betLoading" class="font-medium text-white animate-[fade-in_1.5s_ease-in-out]">{{ betCount }}</span>
        </div>
        <div class="ml-auto w-[150px] relative text-[14px] rounded-zt text-center flex flex-nowrap
                    justify-center items-center"
             :class="{ 'z-backdrop': sortingMenuOpened }">
          <div class="cursor-pointer ml-auto hover:opacity-80" @click="toggleSort()">
            <span v-if="sortingType === 'date'">Godzina dodania</span>
            <span v-else-if="sortingType === 'matchTime'">Godzina spotkania</span>
            <span v-else-if="sortingType === 'ratio'">Kurs</span>
            <span v-else-if="sortingType === 'efficiency'">Skuteczność</span>
            <span v-else-if="sortingType === 'likes'">Popularność</span>
            <span v-else>Nierozliczone</span>
            <svg class="ml-1 inline" :class="{'rotate-180' : sortingMenuOpened}" width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4.25981 5.55C4.14434 5.75 3.85566 5.75 3.74019 5.55L0.795705 0.45C0.680235 0.25 0.824573 6.27296e-07 1.05551 6.07106e-07L6.94449 9.22759e-08C7.17543 7.20865e-08 7.31976 0.25 7.20429 0.45L4.25981 5.55Z" fill="#D9D9D9"/>
            </svg>
          </div>
          <bet-sort-modal :sortingMenuOpened="sortingMenuOpened"
                          :sortingClickOutside="sortingClickOutside"
                          :sortingType="sortingType"
                          :secondarySortingType="secondarySortingType"
                          @toggleSort="toggleSort"
                          @sortBets="sortBets">
          </bet-sort-modal>
        </div>
      </div>
      <button v-if="betStore.newBetsCount" @click="scrollToNewBets"
              class="border-b-2 uppercase border-zt-light text-xs font-semibold mx-auto text-zt-more pb-[6px] px-2.5 zt-hover">
        Pokaż {{ betStore.newBetsCount + ' ' + inflectNumber(betStore.newBetsCount, ['nowy typ', 'nowe typy', 'nowych typów']) }}
      </button>
    </div>

    <div v-if="currentlyAddingBet" class="flex items-center p-4 mt-3 rounded-md">
      <div class="spinner-grow inline-block w-2 h-2 mx-0.5 bg-current rounded-full opacity-0"
           style="animation-duration: 2s; animation-delay: -0.5s;" role="status"></div>
      <div class="spinner-grow inline-block w-2 h-2 mx-0.5 bg-current rounded-full opacity-0"
           style="animation-duration: 2s;" role="status"></div>
      <div class="spinner-grow inline-block w-2 h-2 mx-0.5 bg-current rounded-full opacity-0"
           style="animation-duration: 2s; animation-delay: 0.5s;" role="status"></div>
      <div class="relative text-[14px] flex flex-nowrap justify-center items-center cursor-pointer"
           v-click-outside="currentlyAddingBetClickOutside">
        <span class="ml-2 cursor-pointer" @click="currentlyAddingBetOpened = !currentlyAddingBetOpened"
              v-html="getCurrentlyAddingBetText()"></span>
        <div v-if="currentlyAddingBetOpened"
             class="absolute left-0 top-[160%] z-30 max-w-[300px] rounded-zt bg-zt-normal
             caret text-[16px] font-normal shadow-zt xl:left-[50%] xl:-translate-x-[64%] xl:max-w-[unset]">
          <div v-for="user in currentlyAddingBetUsers"  :key="user.userId" class="sort-item !bg-zt-normal">
            <a :href="'/typer/' + user.userId" class="no-default-style block w-max hover:underline ">
              <div class="whitespace-nowrap overflow-hidden overflow-ellipsis">
                <img :src="user.avatar" alt="Avatar" class="inline h-[30px] w-[30px] rounded-full"
                     width="30" height="30" @error="handleUserAvatarError($event)">
                <span class="text-[14px] ml-3">{{ user.username }}</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>


    <div v-if="(window.size.mobile && selectedFilterCategoryCount > 0 && !filteringMenuOpened)
              || (window.size.desktop && selectedFilterCategoryCount > 0 && !filteringMenuOpened && searchedBets.length > 0)"
      class="text-sm mx-4 flex items-center mt-2 border-b-[2px] border-zt-normal pb-1
      xl:text-base xl:flex-col xl:gap-2 xl:mt-4 xl:-mb-2 xl:border-none xl:mx-0">
      <span class="xl:font-light">Wyniki wyszukiwania:
        <span class="font-medium">{{this.filteredBetsCount}}</span>
      </span>
      <span class="text-zt-red ml-auto cursor-pointer zt-hover font-medium xl:ml-0 xl:font-normal"
            @click.stop="clearFilters()">Wyczyść filtry</span>
    </div>

    <div v-if="searchedBets.length <= 0 && !betLoading" class="w-full flex flex-col items-center gap-4 my-20 xl:gap-9 xl:my-12">
      <div class="bg-[url(/wp-content/themes/zawodtyper/assets/images/brak-wynikow.webp)] bg-cover
             w-[189px] h-[169px] xl:w-[234px] xl:h-[209px]"></div>
      <span class="text-zt-more font-medium text-sm xl:text-base">Brak wyników wyszukiwania...</span>
    </div>

    <div class="relative min-h-8 mt-5">
      <div v-if="betLoading"
           class="backdrop !z-[800] absolute w-[calc(100%_+_2rem)] h-[calc(100%_+_2rem)] -translate-x-4 -translate-y-4 rounded-zt
                  backdrop-blur-sm bg-black/0"></div>
      <div v-if="betLoading"
           class="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-modal flex flex-col justify-center
                items-center pb-8 pt-10 px-10 bg-zt-light-opacity rounded-zt shadow-around-xl w-[250px] xl:w-auto">
        <svg class="mr-2 w-8 h-8 animate-spin fill-zt-red" viewBox="0 0 100 101">
          <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
          <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
        </svg>
        <span class="mt-4 animate-bounce">Ładowanie typów</span>
      </div>

      <TransitionGroup name="fade">
        <template v-for="bet in searchedBets.slice(0, searchedBets.length - blockedBetsCount)" :key="String(bet.comment_id)">
          <component v-show="!betAuthorBlocked(bet.author_id) && !(settingsStore.adsFilter && bet.comment_type === 'bet')"
              :is="bet.comment_type"
              :ref="getRefs(bet.comment_id)"
              :data="bet"
              :isBlocked="betAuthorBlocked(bet.author_id)"
              :isBlocking="betAuthorBlocking(bet.author_id)"
              :isWarned="betAuthorWarned(bet.author_id)"
              :blockedUserIds="blockedUserIds"
              :blockingUserIds="blockingUserIds"
              :warnedUserIds="warnedUserIds"
              :is-modal="false"
              :typ="bet.buk_name"
              :betEdited="betEdited"
              @blockUser="blockAuthor"
              @unblockUser="unblockAuthor"
              @warnUser="warnAuthor"
              @removeWarnUser="removeWarnUser"
              @changeBetDay="changeBetDay"
              @editBetIncrement="editBetIncrement"/>
        </template>
      </TransitionGroup>
    </div>

    <Transition name="fade">
      <template v-if="bets.length > 30 && limitedTimeBonuses && !betLoading">
        <limited-time-bonuses :data="limitedTimeBonuses" :isTd="true" />
      </template>
    </Transition>

    <div v-if="!settingsStore.adsFilter" class="basis-full mx-2 mt-5 flex items-center justify-end pb-1 xl:mx-0">
      <div class="text-[14px] font-normal text-white/50">
        Dodano wpisów:
        <span v-show="!betLoading" class="font-medium text-white animate-[fade-in_1.5s_ease-in-out]">{{ betDiscussionsCount }}</span>
      </div>
      <div class="ml-auto w-[150px] relative text-[14px] rounded-zt text-center flex flex-nowrap
             justify-center items-center"
           :class="{ 'z-backdrop': sortingBetDiscussionMenuOpened }">
        <div class="cursor-pointer ml-auto hover:opacity-80" @click="toggleBetDiscussionSort()">
          <span v-if="sortingBetDiscussionType === 'newest'">Najnowsze</span>
          <span v-else>Najstarsze</span>
          <svg class="ml-1 inline" :class="{'rotate-180' : sortingBetDiscussionMenuOpened}" width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.25981 5.55C4.14434 5.75 3.85566 5.75 3.74019 5.55L0.795705 0.45C0.680235 0.25 0.824573 6.27296e-07 1.05551 6.07106e-07L6.94449 9.22759e-08C7.17543 7.20865e-08 7.31976 0.25 7.20429 0.45L4.25981 5.55Z" fill="#D9D9D9"/>
          </svg>
        </div>
        <bet-sort-modal :sortingMenuOpened="sortingBetDiscussionMenuOpened"
                        :isBetDiscussionSort="true"
                        :sortingClickOutside="sortingBetDiscussionClickOutside"
                        :sortingType="sortingBetDiscussionType"
                        @toggleSort="toggleBetDiscussionSort"
                        @sortBets="sortBetDiscussions">
        </bet-sort-modal>
      </div>
    </div>
    <template v-if="!settingsStore.adsFilter">
      <hr class="border-b border-zt-normal mb-3" />
      <div v-if="isLoggedIn()" class="h-9 flex justify-center items-center mb-3">
        <template v-if="isAddBetAllowed">
          <button v-if="isAddBetDiscussionAllowed === 2 || userCanModerate"
                  class="w-full zt-button no-wrap overflow-hidden text-ellipsis flex flex-nowrap items-center
                    py-2 rounded-zt justify-center mx-3 xl:mx-0"
                  @click="openAddBetModal(true)">
            <span class="mr-2 uppercase">Dodaj wpis</span>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16.8075 0.124453C16.6748 0.199126 14.1193 2.6882 11.1408 5.66678L5.73118 11.0681L4.98446 12.9515C4.19626 14.9344 4.11329 15.2995 4.40368 15.5899C4.69407 15.8803 5.05084 15.7973 7.04209 15.0091L8.92549 14.2624L14.3351 8.85279C17.3054 5.87421 19.7944 3.31876 19.8691 3.16942C20.0516 2.79606 20.0433 2.04933 19.8442 1.66768C19.6534 1.29432 18.6495 0.306985 18.2844 0.124453C17.9442 -0.0414845 17.1394 -0.0414845 16.8075 0.124453ZM18.1185 1.8834C18.3757 2.1489 18.5914 2.4144 18.5914 2.48077C18.5914 2.54715 16.2268 4.96155 13.3477 7.84057C8.49405 12.686 8.06261 13.0925 7.63947 13.2501C7.39056 13.3497 6.95083 13.5156 6.67703 13.6235L6.17092 13.8226L6.90105 11.9807L12.1862 6.6873C15.0901 3.78339 17.5128 1.40218 17.5543 1.40218C17.604 1.40218 17.853 1.6179 18.1185 1.8834Z" fill="white"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M11.1408 5.66678C14.1193 2.6882 16.6748 0.199126 16.8075 0.124453C17.1394 -0.0414845 17.9442 -0.0414845 18.2844 0.124453C18.6495 0.306985 19.6534 1.29432 19.8442 1.66768C20.0433 2.04933 20.0516 2.79606 19.8691 3.16942C19.7944 3.31876 17.3054 5.87421 14.3351 8.85279L8.92549 14.2624L7.04209 15.0091C5.05084 15.7973 4.69407 15.8803 4.40368 15.5899C4.11329 15.2995 4.19626 14.9344 4.98446 12.9515L5.73118 11.0681L11.1408 5.66678ZM5.83925 11.1391L11.2302 5.75641C12.7192 4.26741 14.1025 2.90078 15.1298 1.89725C15.6436 1.39545 16.0681 0.984645 16.3723 0.694776C16.5245 0.549778 16.6462 0.435442 16.7337 0.355237C16.7775 0.315064 16.8121 0.284027 16.8375 0.262186C16.8539 0.247986 16.8636 0.240266 16.8681 0.236667C16.8693 0.235665 16.8702 0.234984 16.8706 0.234569C17.0112 0.166947 17.2675 0.126652 17.5429 0.126652C17.8217 0.126652 18.0843 0.167978 18.2283 0.237996C18.3053 0.276645 18.4267 0.364053 18.5741 0.487262C18.7193 0.608642 18.8824 0.758393 19.0407 0.914643C19.199 1.0709 19.3512 1.23241 19.4751 1.37708C19.6011 1.5242 19.691 1.64628 19.7314 1.72532C19.8183 1.89171 19.8691 2.1526 19.8731 2.42353C19.8771 2.69295 19.8349 2.94892 19.7568 3.11066C19.7563 3.11171 19.7558 3.11275 19.7553 3.11379M19.7568 3.11066C19.7569 3.11067 19.7569 3.11058 19.7568 3.11066C19.7566 3.11049 19.7502 3.11979 19.73 3.14401C19.7084 3.16987 19.6776 3.20508 19.6376 3.2496C19.5576 3.33844 19.4434 3.46129 19.2986 3.61459C19.0089 3.92103 18.5985 4.34702 18.0972 4.86178C17.0948 5.89118 15.7303 7.27432 14.2454 8.76336L8.85446 14.1543L6.99548 14.8913C5.99652 15.2868 5.42004 15.5 5.05766 15.5803C4.87751 15.6202 4.76333 15.624 4.68288 15.6082C4.60783 15.5934 4.55265 15.5597 4.49324 15.5003C4.43408 15.4412 4.40022 15.3855 4.38537 15.3097C4.36948 15.2284 4.37335 15.1133 4.41326 14.9327C4.49355 14.5694 4.70678 13.9929 5.10216 12.9982L5.83925 11.1391M18.2094 1.79527L18.208 1.79384C18.0737 1.65953 17.9427 1.53687 17.8379 1.44706C17.7858 1.40239 17.7383 1.36425 17.6992 1.3366C17.6798 1.32293 17.6601 1.31007 17.6413 1.3001C17.6289 1.29351 17.5949 1.27552 17.5543 1.27552C17.525 1.27552 17.5033 1.28594 17.4992 1.2879C17.4917 1.29144 17.4854 1.29524 17.4823 1.29727C17.4756 1.30154 17.4697 1.30603 17.4656 1.30923C17.4568 1.31605 17.4465 1.32478 17.4356 1.33433C17.4134 1.35382 17.3826 1.38191 17.3444 1.41755C17.2677 1.48908 17.1577 1.59404 17.0184 1.72848C16.7396 1.99751 16.3418 2.38625 15.8548 2.8655C14.8807 3.82408 13.5488 5.1456 12.0966 6.59774L6.79294 11.9097L5.94559 14.0474L6.7234 13.7414C6.84391 13.6939 7.00022 13.6338 7.15825 13.573C7.35214 13.4984 7.54869 13.4228 7.68513 13.3683C7.92437 13.2789 8.1567 13.1176 8.91925 12.3952C9.68823 11.6668 11.011 10.3523 13.4372 7.9302C14.8769 6.49048 16.1883 5.16671 17.1397 4.19451C17.6154 3.70848 18.0014 3.30996 18.2687 3.02862C18.4023 2.88806 18.5068 2.77609 18.5782 2.69683C18.6138 2.6574 18.6422 2.62487 18.6622 2.60046C18.6719 2.58852 18.6813 2.5766 18.6887 2.56581C18.6923 2.56062 18.6972 2.55321 18.7017 2.54467C18.7039 2.5404 18.7072 2.53373 18.7102 2.52542C18.7126 2.51865 18.718 2.50224 18.718 2.48077C18.718 2.44432 18.705 2.41243 18.697 2.39468C18.6873 2.37324 18.6745 2.35096 18.6607 2.32912C18.633 2.28518 18.5948 2.2334 18.5504 2.17775C18.4611 2.06593 18.34 1.93009 18.2094 1.79527ZM6.67703 13.6235C6.80023 13.575 6.95702 13.5147 7.11491 13.454C7.30792 13.3798 7.50256 13.3049 7.63947 13.2501C8.06261 13.0925 8.49405 12.686 13.3477 7.84057C16.2268 4.96155 18.5914 2.54715 18.5914 2.48077C18.5914 2.4144 18.3757 2.1489 18.1185 1.8834C17.853 1.6179 17.604 1.40218 17.5543 1.40218C17.5128 1.40218 15.0901 3.78339 12.1862 6.6873L6.90105 11.9807L6.17092 13.8226L6.67703 13.6235Z" fill="#263042"/>
              <path d="M10.2407 2.23242H9.21393H2C1.44772 2.23242 1 2.68014 1 3.23242V17.6603C1 18.2126 1.44772 18.6603 2 18.6603H16.4279C16.9801 18.6603 17.4279 18.2126 17.4279 17.6603V10.4464V9.41961" stroke="white" stroke-linecap="round"/>
            </svg>
          </button>
          <div v-else-if="isAddBetDiscussionAllowed === 1"
               class="w-full zt-button no-wrap overflow-hidden text-ellipsis  flex flex-nowrap items-center
                 py-2 rounded-zt justify-center bg-[#666666] opacity-70 cursor-default hover:!opacity-none mx-2 xl:mx-0"
               data-bs-trigger="manual" data-bs-toggle="tooltip" data-bs-placement="bottom" data-bs-html="true"
               title='<div class="text-center">Musisz podać co najmniej 20 typów, by tworzyć wpisy.</div>'
               @click="openTooltip()">
            <span class="uppercase mx-auto no-wrap overflow-hidden text-ellipsis">Wymagane dodanie min. X typów</span>
          </div>
        </template>
        <template v-else>
          <div class="w-full zt-button no-wrap overflow-hidden text-ellipsis  flex flex-nowrap items-center
                py-2 rounded-zt justify-center bg-[#666666] opacity-70 cursor-default hover:!opacity-none mx-2 xl:mx-0">
            <span class="uppercase mx-auto no-wrap overflow-hidden text-ellipsis">Nie możesz dodać wpisu, czas minął</span>
          </div>
        </template>
      </div>
      <div v-else
           class="basis-full flex flex-nowrap items-center bg-zt-main py-2 rounded-zt justify-center cursor-pointer
           border-zt-light border-[1px] zt-hover mb-3 mx-3 xl:mx-0"
           @click="openLoginModal">
        <span class="mr-3 uppercase">Zaloguj się, aby dodać wpis</span>
        <svg width="20" height="20" viewBox="4 2 20 20">
          <path d="M13.293 7.293c-0.391 0.391-0.391 1.023 0 1.414l2.293 2.293h-7.586c-0.552 0-1 0.448-1 1s0.448 1 1 1h7.586l-2.293 2.293c-0.391 0.391-0.391 1.023 0 1.414 0.195 0.195 0.451 0.293 0.707 0.293s0.512-0.098 0.707-0.293l4.707-4.707-4.707-4.707c-0.391-0.391-1.023-0.391-1.414 0z" fill="white"></path>
        </svg>
      </div>
      <InfoBox class="font-light mx-2.5 xl:mx-0">
        Ta przestrzeń została stworzona, by umożliwić dzielenie się
        przemyśleniami, analizami oraz typami na nadchodzące wydarzenia sportowe
        bez konieczności brania udziału w turnieju Typów Dnia. Statystyki typów nie
        wliczają się w historię konta.
      </InfoBox>
    </template>

    <div v-if="betStore.newBetDiscussionsCount" class="w-full flex justify-center my-5">
      <button @click="scrollToNewBetDiscussions"
              class="mx-auto border-b-2 uppercase border-zt-light text-xs font-semibold text-zt-more pb-[6px] px-2.5 zt-hover">
        Pokaż {{ betStore.newBetDiscussionsCount + ' ' + inflectNumber(betStore.newBetDiscussionsCount, ['nowy wpis', 'nowe wpisy', 'nowych wpisów']) }}
      </button>
    </div>

    <div v-if="currentlyAddingBetDiscussion" class="flex items-center p-4 mt-3 rounded-md">
      <div class="spinner-grow inline-block w-2 h-2 mx-0.5 bg-current rounded-full opacity-0"
           style="animation-duration: 2s; animation-delay: -0.5s;" role="status"></div>
      <div class="spinner-grow inline-block w-2 h-2 mx-0.5 bg-current rounded-full opacity-0"
           style="animation-duration: 2s;" role="status"></div>
      <div class="spinner-grow inline-block w-2 h-2 mx-0.5 bg-current rounded-full opacity-0"
           style="animation-duration: 2s; animation-delay: 0.5s;" role="status"></div>
      <div class="relative text-[14px] flex flex-nowrap justify-center items-center cursor-pointer"
           v-click-outside="currentlyAddingBetDiscussionClickOutside">
        <span class="ml-2 cursor-pointer" @click="currentlyAddingBetDiscussionOpened = !currentlyAddingBetDiscussionOpened"
              v-html="getCurrentlyAddingBetDiscussionText()"></span>
        <div v-if="currentlyAddingBetDiscussionOpened"
             class="absolute left-0 top-[160%] z-30 max-w-[300px] rounded-zt bg-zt-normal
             caret text-[16px] font-normal shadow-zt xl:left-[50%] xl:-translate-x-[64%] xl:max-w-[unset]">
          <div v-for="user in currentlyAddingBetDiscussionUsers"  :key="user.userId" class="sort-item !bg-zt-normal">
            <a :href="'/typer/' + user.userId" class="no-default-style block w-max hover:underline ">
              <div class="whitespace-nowrap overflow-hidden overflow-ellipsis">
                <img :src="user.avatar" alt="Avatar" class="inline h-[30px] w-[30px] rounded-full"
                     width="30" height="30" @error="handleUserAvatarError($event)">
                <span class="text-[14px] ml-3">{{ user.username }}</span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div v-if="!settingsStore.adsFilter && betDiscussions.length <= 0 && betLoading"
         class="w-full h-full my-20 flex flex-col justify-center items-center">
      <svg class="mr-2 w-8 h-8 animate-spin fill-zt-red" viewBox="0 0 100 101">
        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
      </svg>
      <span class="mt-4 animate-bounce">Ładowanie wpisów dyskusyjnych</span>
    </div>

    <template v-if="!betLoading && !settingsStore.adsFilter">
      <div v-if="betDiscussionsCount === 0"
           class="w-full flex flex-col items-center gap-4 my-10 xl:gap-9 xl:my-10">
        <span class="text-zt-more font-medium text-sm xl:text-base">Brak wpisów</span>
      </div>
      <div v-else-if="searchedBetDiscussions.length <= 0"
           class="w-full flex flex-col items-center gap-4 my-20 xl:gap-9 xl:my-12">
        <div class="bg-[url(/wp-content/themes/zawodtyper/assets/images/brak-wynikow.webp)] bg-cover
              w-[189px] h-[169px] xl:w-[234px] xl:h-[209px]"></div>
        <span class="text-zt-more font-medium text-sm xl:text-base">Brak wyników wyszukiwania...</span>
      </div>
    </template>

    <TransitionGroup name="fade">
      <template v-for="bet in searchedBetDiscussions" :key="String(bet.comment_id)">
        <component v-show="!betAuthorBlocked(bet.author_id) && !settingsStore.adsFilter"
						:is="bet.comment_type"
            :ref="getRefs(bet.comment_id)"
            :data="bet"
            :isBlocked="betAuthorBlocked(bet.author_id)"
            :isBlocking="betAuthorBlocking(bet.author_id)"
            :isWarned="betAuthorWarned(bet.author_id)"
            :blockedUserIds="blockedUserIds"
            :blockingUserIds="blockingUserIds"
            :warnedUserIds="warnedUserIds"
            :is-modal="false"
            :typ="bet.buk_name"
            :betEdited="betEdited"
            @blockUser="blockAuthor"
            @unblockUser="unblockAuthor"
            @warnUser="warnAuthor"
            @removeWarnUser="removeWarnUser"
            @changeBetDay="changeBetDay"
            @editBetIncrement="editBetIncrement"/>
      </template>
    </TransitionGroup>

    <div v-if="blockedBetsCount > 0 && searchedBets.slice(searchedBets.length - blockedBetsCount).length > 0"
         class="basis-full mx-2 flex items-center border-b-[2px] border-zt-normal pb-1 mt-8 xl:mx-0">
      <div class="text-[14px] font-normal text-white/50">
        Ukryte
        <span class="font-semibold text-white">{{ blockedBetsCount }}</span>
        {{ inflectNumber(blockedBetsCount, ['typ', 'typy', 'typów']) }}
      </div>
    </div>
    <TransitionGroup name="fade">
      <template v-for="bet in searchedBets.slice(0, searchedBets.length - blockedBetsCount)" :key="bet.comment_id">
        <component v-show="betAuthorBlocked(bet.author_id)"
						:is="bet.comment_type"
            :ref="getRefs(bet.comment_id)"
            :data="bet"
            :isBlocked="betAuthorBlocked(bet.author_id)"
            :isBlocking="betAuthorBlocking(bet.author_id)"
            :isWarned="betAuthorWarned(bet.author_id)"
            :blockedUserIds="blockedUserIds"
            :blockingUserIds="blockingUserIds"
            :warnedUserIds="warnedUserIds"
            :is-modal="false"
            :typ="bet.buk_name"
            @blockUser="blockAuthor"
            @unblockUser="unblockAuthor"
            @warnUser="warnAuthor"
            @removeWarnUser="removeWarnUser"/>
      </template>
    </TransitionGroup>

    <div v-if="blockedBetDiscussionsCount > 0 && searchedBetDiscussions.slice(searchedBetDiscussions.length - blockedBetDiscussionsCount).length > 0"
         class="basis-full mx-2 flex items-center border-b-[2px] border-zt-normal pb-1 mt-4 xl:mx-0">
      <div class="text-[14px] font-normal text-white/50">
        Ukryte
        <span class="font-semibold text-white">{{ blockedBetDiscussionsCount }}</span>
        {{ inflectNumber(blockedBetDiscussionsCount, ['wpis', 'wpisy', 'wpisów']) }}
      </div>
    </div>
    <TransitionGroup name="fade">
      <template v-for="bet in searchedBetDiscussions.slice(0, searchedBetDiscussions.length - blockedBetDiscussionsCount)" :key="bet.comment_id">
        <component v-show="betAuthorBlocked(bet.author_id)"
						:is="bet.comment_type"
            :ref="getRefs(bet.comment_id)"
            :data="bet"
            :isBlocked="betAuthorBlocked(bet.author_id)"
            :isBlocking="betAuthorBlocking(bet.author_id)"
            :isWarned="betAuthorWarned(bet.author_id)"
            :blockedUserIds="blockedUserIds"
            :blockingUserIds="blockingUserIds"
            :warnedUserIds="warnedUserIds"
            :is-modal="false"
            :typ="bet.buk_name"
            @blockUser="blockAuthor"
            @unblockUser="unblockAuthor"
            @warnUser="warnAuthor"
            @removeWarnUser="removeWarnUser"/>
      </template>
    </TransitionGroup>

    <div class="rounded-zt text-sm border border-zt-light bg-zt-light/35 mx-2.5 py-3 px-4 flex items-center justify-between xl:mx-0">
      <div class="flex flex-col gap-y-1">
        <span class="font-semibold">Masz problem, pytanie? {{ window.size.desktop ? 'Napisz do nas' : '' }}</span>
      </div>
      <a href="/kontakt/" data-count-click="Kontakt na dole Pojed. TD" class=" no-default-style zt-hover cursor-pointer bg-zt-red rounded-zt w-[176px] h-[45px] flex items-center justify-center gap-x-[6px]">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M20 3H4C1.8 3 0 4.8 0 7V17C0 19.2 1.8 21 4 21H20C22.2 21 24 19.2 24 17V7C24 4.8 22.2 3 20 3ZM21.6 8.8L13.7 14.1C13.2 14.4 12.6 14.6 12 14.6C11.4 14.6 10.8 14.4 10.3 14.1L2.4 8.8C2 8.5 1.9 7.9 2.2 7.4C2.5 7 3.1 6.9 3.6 7.2L11.5 12.5C11.8 12.7 12.3 12.7 12.6 12.5L20.5 7.2C21 6.9 21.6 7 21.9 7.5C22.1 7.9 22 8.5 21.6 8.8Z" fill="white"/>
        </svg>
        <span class="uppercase font-semibold">Skontaktuj się</span>
      </a>

    </div>
  </section>
</template>

<script>
import Comment from '../Comment.vue';
import Popper from 'vue3-popper';
import AddBetModal from '../modals/AddBetModal.vue';
import { useBetStore } from '../../stores/BetStore.js';
import utils_mixin from '../../mixins/utils_mixin';
import { useUserStore } from '../../stores/UserStore';
import BannerKoszulka from "../blocks/BannerKoszulka.vue";
import LimitedTimeBonuses from "../daily_bets_items/LimitedTimeBonuses.vue";
import OtherPosts from "../daily_bets_items/OtherPosts.vue";
import BetAd from "../daily_bets_items/BetAd.vue";
import BetDiscussion from "../daily_bets_items/BetDiscussion.vue";
import BetItem from "../BetItem.vue";
import CouponModal from "../modals/CouponModal.vue";
import BetSortModal from "../modals/BetSortModal.vue";
import BetFilterModal from '../modals/BetFilterModal.vue';
import InfoBox from '../football_stats/blocks/InfoBox.vue';
import { useSettingsStore } from "../../stores/SettingsStore";
import { toRaw } from 'vue';
import BetsCalendar from "../../components/daily_bets_tabs/BetsCalendar.vue";
import BetAdSuppi from '../daily_bets_items/ads/BetAdSuppi.vue';

export default {
  name: 'Bets',
  inject: ['WP'],
  emits: ['close-modal'],
  mixins: [utils_mixin],
  components: {
    advert: BetAd,
    ticket: BannerKoszulka,
    bet: BetItem,
    betDiscussion: BetDiscussion,
    LimitedTimeBonuses: LimitedTimeBonuses,
    posts: OtherPosts,
    AddBetModal: AddBetModal,
    Comment: Comment,
    CouponModal,
    Popper,
    BetSortModal,
    BetFilterModal,
    InfoBox,
    BetsCalendar,
    bet_ad_suppi: BetAdSuppi,
  },
  setup() {
    const betStore = useBetStore();
    const userStore = useUserStore();
	  const settingsStore = useSettingsStore();
    return { betStore, userStore, settingsStore };
  },
  data() {
    this.secondsSinceLastActivity = 0;
    this.secondsSinceFormOpening = 0;
    this.numberOfBetsToDownload = 5;
    return {
      odds: {
        min: 0,
        max: 999
      },
      showOnlyNotPlayedYet: false,
      showOnlyFollowedUsers: false,
      betLoading: true,
      filteredBetsCount: 0,
      allBets: [],
      bets: [],
      betDiscussions: [],
      message: '',
      sortingType: 'date',
      sortingBetDiscussionType: 'newest',
      secondarySortingType:'',
      searchInput: '',
      analysis: '',
      rate: '',
      hour: '',
      bookmaker: 'Fortuna',
      discipline: 'Piłka nożna',
      type: '',
      match_name: '',
      betEdited: 1,
      errors: [],
      blockedUserIds: [],
      blockingUserIds: [],
      warnedUserIds: [],
      userCanAddCommentTypeBet: false,
      isComment: false,
      sortingMenuOpened: false,
      sortingBetDiscussionMenuOpened: false,
      currentlyAddingBetOpened: false,
      currentlyAddingBetDiscussionOpened: false,
      filteringMenuOpened: false,
      isOpenForm: false,
      isBetDiscussion: false,
      notificationBets: [],
      notificationBetDiscussions: [],
      searchInputFocus: false,
      searchInputTimeout: null,
      searchInputTemp: '',
      minGap: 0,
      disciplineAllSelected: true,
      disciplineRestSelected: false,
      lastBetTimestamp: 0,
      filteredBets: null,
      sortedBets: [],
      groupedBets: [],
      sortedBetDiscussions: [],
      groupedBetDiscussions: [],
      userCanSettle: false,
      userCanModerate: false,
      commentsMap: new Map(),
      currentlyAddingBetUsers: [],
      currentlyAddingBetDiscussionUsers: [],
      otherDisciplinesCount: 0,
      offset: 0,
      blockedBetsCount: 0,
      blockedBetDiscussionsCount: 0,
      userAddingOnAnotherPage: false,
      featuredBookmakers: [],
      isAddBetAllowed: false,
      isAddBetDiscussionAllowed: 2,
      limitedTimeBonuses: [],
      ads: [],
      adsDetails: [],
      adsMinGap: 20,
      isCouponModalOpen: false,
      coupon: [],
      sortingClickOutside: {
        handler: () => {
          if (this.sortingMenuOpened) {
            this.sortingMenuOpened = false;
            this.unblockScrolling();
          }
        },
        events: ['touchend', 'mouseup']
      },
      sortingBetDiscussionClickOutside: {
        handler: () => {
          if (this.sortingBetDiscussionMenuOpened) {
            this.sortingBetDiscussionMenuOpened = false;
            this.unblockScrolling();
          }
        },
        events: ['touchend', 'mouseup']
      },
      filteringClickOutside: {
        handler: () => {
          if (this.filteringMenuOpened) {
            this.filteringMenuOpened = false;
            this.unblockScrolling();
          }
        },
        events: ['touchend', 'mouseup']
      },
      searchingClickOutside: {
        handler: this.outsideClick,
        events: ['touchend', 'mouseup']
      },
      currentlyAddingBetClickOutside: {
        handler: () => { this.$nextTick(()=>{this.currentlyAddingBetOpened = false}) },
        events: ['touchend', 'mouseup']
      },
      currentlyAddingBetDiscussionClickOutside: {
        handler: () => { this.$nextTick(()=>{this.currentlyAddingBetDiscussionOpened = false}) },
        events: ['touchend', 'mouseup']
      }
    };
  },
  computed: {
    disciplines() {
      return this.allDisciplines;
    },
    searchedBets() {
        const regExp = new RegExp('<span>|<[\x2f]span>', "igm");
        const inputWithoutCaseSensitivity = new RegExp(this.searchInputTemp.toLowerCase().replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&'), "i");

        if (this.searchInputTemp.length === 0) {
          return this.groupedBets.map(bet => {
            const modifiedBet = { ...bet };

            if (modifiedBet.bookmaker) {
                modifiedBet.author_name = modifiedBet.author_name.replaceAll(regExp, '');
                modifiedBet.discipline = modifiedBet.discipline.replaceAll(regExp, '');
                modifiedBet.bookmaker = modifiedBet.bookmaker.replaceAll(regExp, '');
                modifiedBet.match_name = modifiedBet.match_name.replaceAll(regExp, '');
                modifiedBet.type = modifiedBet.type.replaceAll(regExp, '');
                modifiedBet.content = modifiedBet.content.replaceAll(regExp, '');
            }

            return modifiedBet;
          });
        }

        return this.groupedBets.map(bet => {
            const modifiedBet = { ...bet };
            
            if (modifiedBet.bookmaker) {
                modifiedBet.author_name = modifiedBet.author_name.replace(inputWithoutCaseSensitivity, '<span class="searched-element">$&</span>');
                modifiedBet.discipline = modifiedBet.discipline.replace(inputWithoutCaseSensitivity, '<span class="searched-element">$&</span>');
                modifiedBet.bookmaker = modifiedBet.bookmaker.replace(inputWithoutCaseSensitivity, '<span class="searched-element">$&</span>');
                modifiedBet.match_name = modifiedBet.match_name.replace(inputWithoutCaseSensitivity, '<span class="searched-element">$&</span>');
                modifiedBet.type = modifiedBet.type.replace(inputWithoutCaseSensitivity, '<span class="searched-element">$&</span>');
                modifiedBet.content = modifiedBet.content.replace(inputWithoutCaseSensitivity, '<span class="searched-element">$&</span>');
            }
            
            return modifiedBet;
        }).filter(bet => {
            if (bet.bookmaker) {
                const input = this.searchInputTemp.toLowerCase();
                
                return (
                    bet.author_name.toLowerCase().includes(input) ||
                    (bet.discipline ? bet.discipline.toLowerCase().includes(input) : false) ||
                    (bet.bookmaker ? bet.bookmaker.toLowerCase().includes(input) : false) ||
                    (bet.match_name ? bet.match_name.toLowerCase().includes(input) : false) ||
                    (bet.type ? bet.type.toLowerCase().includes(input) : false) ||
                    (bet.content ? bet.content.toLowerCase().includes(input) : false)
                );
            } else {
                return false;
            }
        });
    },
    searchedBetDiscussions() {
      const regExp = new RegExp('<span>|<[\x2f]span>', "igm");
      const inputWithoutCaseSensitivity = new RegExp(this.searchInputTemp.toLowerCase().replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&'), "i");

      if (!this.disciplineAllSelected || this.odds.max !== 999 || this.odds.min !== 0 || this.showOnlyNotPlayedYet) {
        return [];
      }

      if (this.searchInputTemp.length === 0) {
        return this.groupedBetDiscussions.map(bet => {
          const modifiedBet = { ...bet };

          modifiedBet.author_name = modifiedBet.author_name.replaceAll(regExp, '');
          modifiedBet.content = modifiedBet.content.replaceAll(regExp, '');

          return modifiedBet;
        }).filter(bet => {
          if (this.showOnlyFollowedUsers && !this.userStore.isUserFollowed(bet.author_id)) {
            return false;
          } else {
            return true;
          }
        });
      }

      return this.groupedBetDiscussions.map(bet => {
          const modifiedBet = { ...bet };
          
          modifiedBet.author_name = modifiedBet.author_name.replace(inputWithoutCaseSensitivity, '<span class="searched-element">$&</span>');
          modifiedBet.content = modifiedBet.content.replace(inputWithoutCaseSensitivity, '<span class="searched-element">$&</span>');
                     
          return modifiedBet;
      }).filter(bet => {
          const input = this.searchInputTemp.toLowerCase();

          if (this.showOnlyFollowedUsers && !this.userStore.isUserFollowed(bet.author_id)) {
            return false;
          }

          return (
            bet.author_name.toLowerCase().includes(input) ||
            (bet.content ? bet.content.toLowerCase().includes(input) : false)
          );
      });
    },
    currentlyAddingBet() {
      return this.currentlyAddingBetUsers.length > 0;
    },
    currentlyAddingBetDiscussion() {
      return this.currentlyAddingBetDiscussionUsers.length > 0;
    },
    selectedFilterCategoryCount() {
      let count = 0;
      if (!this.disciplineAllSelected) {
        count++;
      }
      if (this.odds.min !== 0 || this.odds.max !== 999) {
        count++;
      }
      if (this.showOnlyNotPlayedYet || this.showOnlyFollowedUsers) {
        count++;
      }
      return count;
    },
    betCount() {
      return this.bets.slice().filter(bet => {
        return bet.comment_type === "bet" && Number(bet.comment_approved) === 1;
      }).length;
    },
    betDiscussionsCount() {
      return this.betDiscussions.slice().filter(betDiscussion => {
        return betDiscussion.comment_type === "betDiscussion" && Number(betDiscussion.comment_approved) === 1;
      }).length;
    },
    allBetsCount(){
      let filteredBets = this.bets.slice();
      if (this.showOnlyNotPlayedYet) {
        filteredBets = filteredBets.filter(item => {
          if (item.hour === null) {
            return true;
          }

          const hours = item.hour.split(':')[0];
          const minutes = item.hour.split(':')[1];

          const matchDate = new Date(this.WP.dailyBetsDate);
          matchDate.setHours(hours);
          matchDate.setMinutes(minutes);

          let now = new Date();
          return matchDate >= now;
        });
      }
      if (this.showOnlyFollowedUsers) {
        filteredBets = filteredBets.filter(item => {
          return this.userStore.isUserFollowed(item.author_id);
        });
      }
      filteredBets = filteredBets.filter(item => {
        return item.rate === null || (Number(item.rate) >= Number(this.odds.min) && Number(item.rate) <= (Number(this.odds.max) === 5.0 ? 999 : Number(this.odds.max)));
      });
      return filteredBets.length;
    },
    filteredBetCount(){
      if (this.filteredBets !== null) {
        return this.filteredBets.length;
      }
      return this.bets.length;
    },
    scrollToNewBets() {
      if (this.notificationBets.length <= 0) {
        return;
      }
      this.bets = this.bets.concat(this.notificationBets);
      let firstNewBetId = this.notificationBets[0].comment_id;
      this.notificationBets = [];
      this.betStore.newBetsCount = 0;
      this.sortBets();
      this.$nextTick(() => {
        const newBet = document.getElementById(`comment-${firstNewBetId}`);
        newBet?.scrollIntoView({ behavior: 'smooth', 'inline': 'start'});
      });
    },
    scrollToNewBetDiscussions() {
      if (this.notificationBetDiscussions.length <= 0) {
        return;
      }
      this.betDiscussions = this.betDiscussions.concat(this.notificationBetDiscussions);
      let firstNewBetDiscussionId = this.notificationBetDiscussions[0].comment_id;
      this.notificationBetDiscussions = [];
      this.betStore.newBetDiscussionsCount = 0;
      this.sortBetDiscussions();
      this.$nextTick(() => {
        const newBetDiscussion = document.getElementById(`comment-${firstNewBetDiscussionId}`);
        newBetDiscussion?.scrollIntoView({ behavior: 'smooth', 'inline': 'start'});
      });
    }
  },
  watch: {
    betLoading() {
      if (!this.betLoading) {
        this.unblockScrolling();
        setTimeout(() => {
          this.goToAnchorElement();
        }, 500);
      }
    },
    sortingType() {
      if (this.sortingType === 'date') {
        localStorage.removeItem('sortType');
      } else {
        localStorage.setItem('sortType', this.sortingType);
      }
    },
    sortingBetDiscussionType() {
      if (this.sortingBetDiscussionType === 'newest') {
        localStorage.removeItem('sortBetDiscussionType');
      } else {
        localStorage.setItem('sortBetDiscussionType', this.sortingBetDiscussionType);
      }
    },
    showOnlyNotPlayedYet() {
      this.filterBets(false);
      this.calculateBetCountByCategory();
    },
    showOnlyFollowedUsers() {
      this.filterBets(false);
      this.calculateBetCountByCategory();
    },
  },
  activated() {
    if ((window.size.mobile && this.betStore.lastScrollPosition > 130) || window.size.desktop) {
      window.scrollTo(0, this.betStore.lastScrollPosition);
    } 
  },
  mounted() {
    this.userCanSettle = this.WP.user.role === 'Admin' || this.WP.user.role === 'Moderator';
    this.userCanModerate = this.WP.user.role === 'Admin' || this.WP.user.role === 'Moderator';
    this.userCanAddCommentTypeBet = this.WP.user.role === 'Admin' || this.WP.user.role === 'Moderator' || this.WP.user.role === 'Redaktor';
    if (this.isLoggedIn()) {
      this.getBlockedUsersIds();
      this.getBlockingUsersIds();
      if (this.userCanModerate) {
        this.getWarnedUsersIds();
      }
    }
    this.userStore.getLikedCommentIds();
    this.getBets();
    this.checkIfAddBetIdAllowed();
    // this.checkIfAddBetDiscussionAllowed();
    this.getAds();

    if (webSocketsEnabled) {
      this.addWSListeners();
    }
    this.emitter.on('bettingTipsModalCloseButtonClicked', () => this.$emit('close-modal'));
  },
  methods: {
    checkIfAddBetIdAllowed() {
      let dailyBetsDate = this.DateTime.fromSQL(this.WP.dailyBetsDate);
      let today = this.DateTime.now();
      let diffInDays = this.Interval.fromDateTimes(today, dailyBetsDate).length('days');
      const date = new Date();
      if (today.hasSame(dailyBetsDate, 'day')) {
        this.isAddBetAllowed = true;
      } else if (diffInDays > 0 && diffInDays < 3) {
        this.isAddBetAllowed = true;
      } else if (diffInDays === 3) {
        this.isAddBetAllowed = (date.getHours() >= 21 && date.getHours() < 24);
      }
    },
    openTooltip() {
      for (const element of event.composedPath()) {
        if (typeof element === 'object' && element !== null && 'getAttribute' in element && element.hasAttributes()) {
          for (const attr of element.attributes) {
            if (attr.name === 'data-tooltip-created') {
              setTimeout(() => {
                let tooltip = Tooltip.getInstance(element);
                tooltip.show();
                setTimeout(() => {
                  tooltip.hide();
                }, 4000);
              }, 0);
              return;
            }
          }
        }
      }
    },
    isBetFeatured(bet) {
      const regex = /<span>|<\x2fspan>/ig
      if (this.featuredBookmakers.findIndex(el => el.bet_id === bet.comment_id) >= 0) {
        return true;
      } else {
        if (this.featuredBookmakers.findIndex(el => {
          return el.bookmaker === bet.bookmaker?.replace(regex, '');
        }) >= 0) {
          return false;
        } else {
          this.featuredBookmakers.push({'bookmaker': bet.bookmaker?.replace(regex, ''), 'bet_id': bet.comment_id});
          return true;
        }
      }
    },
    getFeaturedBets() {
      const regex = /<span>|<\x2fspan>/ig
      this.bets.forEach(bet => {
        if (this.featuredBookmakers.findIndex(el => {
          return el.bookmaker === bet.bookmaker?.replace(regex, '');
        }) >= 0) {
        } else {
          this.featuredBookmakers.push({'bookmaker': bet.bookmaker?.replace(regex, ''), 'bet_id': bet.comment_id});
        }
      });
      this.featuredBookmakers.forEach(bookmaker => {
        let filterbets = this.bets.filter(el => {
          return el.bookmaker === bookmaker.bookmaker;
        })
        bookmaker.bet_id = filterbets[filterbets.length - 1]?.comment_id;
      });
    },
    compositionUpdate(event) {
      this.searchInput = event.data;
    },
    clearFilters() {
      this.odds.max = 999;
      this.odds.min = 0;
      this.showOnlyFollowedUsers = false;
      this.showOnlyNotPlayedYet = false;
      this.disciplineAllSelected = true;
      this.filteredBetsCount = this.betCount;
      this.disciplines.forEach((el) => {
        el.search = true;
      });
      this.searchInput = '';
      this.searchInputTemp = '';
      this.filterBets(true);
      this.calculateBetCountByCategory();
      this.filteredBets = null;
    },
    toggleOnlyNotPlayedYet() {
      this.showOnlyNotPlayedYet = !this.showOnlyNotPlayedYet;
          },
    toggleOnlyFollowedUsers() {
      this.showOnlyFollowedUsers = !this.showOnlyFollowedUsers;
    },
    sortBets(onlyTypes = false, sortingType = 'date', secondarySortingType = '', reverse = false) {
      let bets, adverts, ads;

      this.sortingMenuOpened = false;
      this.sortingType = sortingType;
      this.secondarySortingType = secondarySortingType;

      if (this.filteredBets === null) {
        bets = this.bets;
      } else {
        bets = this.filteredBets;
      }

      if (onlyTypes) {
        bets = bets.filter((x) => x.bookmaker != null);
      }

      ads = this.bets.filter(bet => bet.comment_type.startsWith('bet_ad_'));
      bets = bets.filter(bet => !bet.comment_type.startsWith('bet_ad_'));

      switch (this.sortingType) {
        case 'ratio':
          this.sortedBets = bets.sort((a, b) => {
            if (Number(b.rate) === Number(a.rate)) {
              return a.result === "1" ? -1 : 1;
            }
            if (reverse) {
              return Number(a.rate) - Number(b.rate);
            }
            return Number(b.rate) - Number(a.rate);
          });
          break;
				case 'matchTime':
          bets = bets.sort((a, b) => {
            let aT = a.hour != null ? a.hour.split(':') : [0, 0],
                bT = b.hour != null ? b.hour.split(':') : [0, 0];
            let aTime = Number(aT[0] * 60) + Number(aT[1]),
                bTime = Number(bT[0] * 60) + Number(bT[1]);

            if (aTime === bTime) {
              return a.result === "1" ? -1 : 1;
            }
            if (reverse) {
              return bTime - aTime;
            }
            return aTime - bTime;
          })
          adverts = bets.filter(bet => bet.comment_type === 'advert');
					bets = bets.filter(bet => bet.comment_type !== 'advert' && !bet.comment_type.startsWith('bet_ad_'));
					this.sortedBets = [...bets, ...adverts];
          break;
        case 'likes':
          this.sortedBets = bets.sort((a, b) => {
            if (b.like_count === a.like_count) {
              return a.result === "1" ? -1 : 1;
            }

            if (reverse) {
              return a.like_count - b.like_count;
            }
            return b.like_count - a.like_count;
          });
          break;
				case 'settled':
          this.sortedBets = bets.sort((a, b) => {
            let sortScore = Math.abs(b.settled) - Math.abs(a.settled);
            if (sortScore === 0) {
              switch (this.secondarySortingType) {
                case 'hour':
                  let aT = a.hour != null ? a.hour.split(':') : [0, 0],
                      bT = b.hour != null ? b.hour.split(':') : [0, 0];
                  let aTime = Number(aT[0] * 60) + Number(aT[1]),
                      bTime = Number(bT[0] * 60) + Number(bT[1]);
                  if (reverse) {
                    return bTime - aTime;
                  }
                  return aTime - bTime;
                case 'discipline':
                  if (reverse) {
                    if (a.discipline > b.discipline)
                      return -1;
                    if (a.discipline < b.discipline)
                      return 1;
                  } else {
                    if (a.discipline > b.discipline)
                      return 1;
                    if (a.discipline < b.discipline)
                      return -1;
                  }
                  return 0;
              }
            }
            if (sortScore > 0) {
              return -1;
            }
            return 1;
          });
          adverts = this.sortedBets.filter(bet => bet.comment_type === 'advert');
					bets = this.sortedBets.filter(bet => bet.comment_type !== 'advert' && !bet.comment_type.startsWith('bet_ad_'));
					this.sortedBets = [...bets, ...adverts];
          break;
        case 'efficiency':
          this.sortedBets = bets.sort((a, b) => {
            if (b.author_stats.ratio - a.author_stats.ratio === 0) {
              return a.result === "1" ? -1 : 1;
            }
            if (reverse) {
              return a.author_stats.ratio - b.author_stats.ratio;
            }
            return b.author_stats.ratio - a.author_stats.ratio;
          });
          break;
        case 'date':
        default:
          this.sortedBets = bets.sort((a, b) => {
            if (reverse) {
              return new Date(a.date) - new Date(b.date);
            }
            return new Date(b.date) - new Date(a.date);
          });
      }

      if (this.sortedBets.length > 10) {
        this.sortedBets.splice(10, 0, ...ads);
      }

      this.groupBets();
    },
    sortBetDiscussions(sortingType = 'newest') {
      let betDiscussions = this.betDiscussions;

      this.sortingBetDiscussionMenuOpened = false;
      this.sortingBetDiscussionType = sortingType;

      switch (this.sortingBetDiscussionType) {
        case 'oldest':
          this.sortedBetDiscussions = betDiscussions.sort((a, b) => new Date(a.date) - new Date(b.date));
          break;
        case 'newest':
        default:
          this.sortedBetDiscussions = betDiscussions.sort((a, b) => new Date(b.date) - new Date(a.date));
      }

      this.groupBetDiscussions();
    },
    groupBets() {
      const pinnedToAll = this.sortedBets.filter(item => Number(item.pinned_to_all) === 1);
      let betWithoutBlock = this.sortedBets.filter(item => !this.blockedUserIds.includes(Number(item.author_id)
          && Number(item.pinned_to_all) === 0));
      const blockedBets = this.sortedBets.filter(item => this.blockedUserIds.includes(Number(item.author_id))
          && Number(item.pinned_to_all) === 0);

      this.blockedBetsCount = blockedBets.length;

      this.resetShownAddCount();
      let lastShownAdIndex = 0;
      let betWithAds = betWithoutBlock.reduce((arr, el, i) => {
        arr.push(el);
        //bonusy limitowane czasowo
        // if (this.checkToAddAdvertType(lastShownAdIndex, i, 'bonuses')) {
        //   this.getAdMaxShowCount('bonuses') > 1 ? this.addReapetedAd('bonuses', i, arr) : this.addSingleAd('bonuses', i, arr);
        //   lastShownAdIndex = i;
        // }
        //posty
        if (this.checkToAddAdvertType(lastShownAdIndex, i, 'posts')) {
          this.getAdMaxShowCount('posts') > 1 ? this.addReapetedAd('posts', i, arr) : this.addSingleAd('posts', i, arr);
          lastShownAdIndex = i;
        }
        //bilety
        if (this.checkToAddAdvertType(lastShownAdIndex, i, 'ticket')) {
          this.getAdMaxShowCount('ticket') > 1 ? this.addReapetedAd('ticket', i, arr) : this.addSingleAd('ticket', i, arr);
          lastShownAdIndex = i;
        }
        return arr;
      }, [])
      // // testowo bonusy na sam koniec typów
      // if (this.checkToAddAdvertType(lastShownAdIndex, betWithAds.length - 1, 'bonuses')) {
      //   this.addSingleAd('bonuses', betWithAds.length - 1, betWithAds)
      // }
      
      //koniec reklam
      this.groupedBets = pinnedToAll.concat(betWithAds, blockedBets);
    },
    groupBetDiscussions() {
      const pinnedToAll = this.sortedBetDiscussions.filter(item => Number(item.pinned_to_all) === 1);
      let betDiscussionsWithoutBlock = this.sortedBetDiscussions.filter(item => !this.blockedUserIds.includes(Number(item.author_id)
          && Number(item.pinned_to_all) === 0));
      const blockedBetDiscussions = this.sortedBetDiscussions.filter(item => this.blockedUserIds.includes(Number(item.author_id))
          && Number(item.pinned_to_all) === 0);

      this.blockedBetDiscussionsCount = blockedBetDiscussions.length;

      this.groupedBetDiscussions = pinnedToAll.concat(betDiscussionsWithoutBlock, blockedBetDiscussions);
    },
    filterBets(saveFilters) {
      let filteredBets;
      if (!saveFilters) {
        filteredBets = this.bets.slice().filter(item => item.rate === null
          || (Number(item.rate) >= Number(this.odds.min)
            && Number(item.rate) <= (Number(this.odds.max) === 5.0 ? 999 : Number(this.odds.max))));
      } else {
        filteredBets = this.bets.filter(item => item.rate === null
          || (Number(item.rate) >= Number(this.odds.min)
            && Number(item.rate) <= (Number(this.odds.max) === 5.0 ? 999 : Number(this.odds.max))));
      }
      if (this.showOnlyNotPlayedYet) {
        filteredBets = filteredBets.filter(item => {
          if (item.hour === null) {
            return true;
          }

          const hours = item.hour.split(':')[0];
          const minutes = item.hour.split(':')[1];

          const matchDate = new Date(this.WP.dailyBetsDate);
          matchDate.setHours(hours);
          matchDate.setMinutes(minutes);

          let now = new Date();

          return matchDate >= now;
        });
      }
      if (this.showOnlyFollowedUsers) {
        filteredBets = filteredBets.filter(item => {
          return this.userStore.isUserFollowed(item.author_id);
        });
      }

      const selectedDisciplineCount = this.disciplines.filter(x => x.search === true).length;
      if (!this.disciplineAllSelected && selectedDisciplineCount > 0) {
        this.filteredBets = filteredBets.filter(item => {
          return (this.disciplines.some(e => e.title === item.discipline && e.search) || (this.disciplines.slice(-1)[0].search === true ? this.otherDisciplines.some(el => el.title === item.discipline) : false));
        });
      } else {
        this.filteredBets = filteredBets;
      }
      if (saveFilters) {
        this.sortBets();
      }
    },
    toggleDiscipline(discipline) {
      if (discipline === 'all') {
        if (!this.disciplineAllSelected) {
          this.disciplineAllSelected = !this.disciplineAllSelected;
          this.disciplines.forEach(el => {
            el.search = this.disciplineAllSelected;
          })
        }
      } else if (this.disciplineAllSelected) {
        this.disciplineAllSelected = false;
        this.disciplines.forEach(el => {
          if (el.title === discipline.title) {
            el.search = true;
          } else {
            el.search = false;
          }
        })
      } else {
        const index = this.disciplines.findIndex(obj => obj.title === discipline.title);
        if (index !== -1) {
          this.disciplines[index].search = !this.disciplines[index].search;
          let allNotSelected = this.disciplines.filter(el => {
            return el.search === false;
          });
          if (allNotSelected.length === this.disciplines.length || allNotSelected.length === 0) {
            this.disciplineAllSelected = true;
            this.disciplines.forEach(el => {
              el.search = true;
            })
          } else {
            this.disciplineAllSelected = false;
          }
        }
      }
      let count = 0;
      this.disciplines.forEach((el) => {
        if (el.search) count += el.count
      })
      this.filteredBetsCount = count;
    },
    outsideClick() {
      this.searchInputFocus = false;
    },
    outsideUserListClick() {
      this.searchUserInputFocus = false;
    },
    getBets() {
      this.blockScrolling();

      axios
          .post(this.WP.ajaxUrl, {
            endpoint: 'api_get_bets_by_post_id',
            post_id: this.WP.id,
            offset: this.offset,
            count: this.numberOfBetsToDownload
          })
          .then(response => {
            let comments1Lvl = response.data.data.filter(comment => Number(comment.parent_id) === 0);
            let comments2Lvl = response.data.data.filter(comment =>
                comments1Lvl.some(lvl1Comment => Number(lvl1Comment.comment_id) === Number(comment.parent_id)));
            let comments3Lvl = response.data.data.filter(comment =>
                comments2Lvl.some(lvl2Comment => Number(lvl2Comment.comment_id) === Number(comment.parent_id)));
            comments1Lvl.forEach(comment => (comment.answers = []));
            comments2Lvl.forEach(comment => (comment.answers = []));
            comments3Lvl.forEach(nestedComment => {
              comments2Lvl.find(parent => Number(parent.comment_id) === Number(nestedComment.parent_id))
                  ?.answers.push(nestedComment);
            });
            comments2Lvl.forEach(nestedComment => {
              comments1Lvl.find(parent => Number(parent.comment_id) === Number(nestedComment.parent_id))
                  ?.answers.push(nestedComment);
            });

            this.allBets = this.allBets.concat(comments1Lvl);

            this.bets = this.bets.concat(comments1Lvl.filter(bet => bet.comment_type != 'betDiscussion'));

            this.betDiscussions = this.betDiscussions.concat(comments1Lvl.filter(bet => bet.comment_type === 'betDiscussion'));

            if (this.sortingType === 'date') {
              this.sortBets();
            }
            if (this.sortingBetDiscussionType === 'newest') {
              this.sortBetDiscussions();
            }

            if (comments1Lvl.length >= this.numberOfBetsToDownload) { // there may still be bets left to download
              this.offset = this.allBets.length;
              this.numberOfBetsToDownload += 500;
              this.getBets();
            } else {
              this.calculateBetCountByCategory();
              this.getFeaturedBets();
              this.$nextTick(() => this.betLoading = false);
            }
          });
    },
    betAuthorBlocked(authorId) {
      return this.blockedUserIds.includes(Number(authorId));
    },
    betAuthorBlocking(authorId) {
      return this.blockingUserIds.includes(Number(authorId));
    },
    blockAuthor(authorId) {
      this.blockedUserIds.push(Number(authorId));
      this.filterBets(true);
      this.sortBetDiscussions();
    },
    unblockAuthor(authorId) {
      let index = this.blockedUserIds.findIndex(userId => userId === Number(authorId));
      this.blockedUserIds.splice(index, 1);
      this.filterBets(true);
      this.sortBetDiscussions();
    },
    betAuthorWarned(authorId) {
      return this.warnedUserIds.some( (el) => {
        return el.user_id === Number(authorId);
      });
    },
    warnAuthor(authorId) {
      if (this.betAuthorWarned(authorId)){
        let index = this.warnedUserIds.findIndex((el) => {
          return el.user_id === Number(authorId);
        });
        this.warnedUserIds[index].warn_count++;
      } else {
        this.warnedUserIds.push({user_id:Number(authorId), warn_count: 1});
      }
    },
    removeWarnUser(authorId) {
      let index = this.warnedUserIds.findIndex((el) => {
        return el.user_id === Number(authorId);
      });
      if (this.warnedUserIds[index].warn_count === 1){
        this.warnedUserIds.splice(index, 1);
      } else {
        this.warnedUserIds[index].warn_count--;
      }
    },
    goToAnchorElement() {
      let anchor = window.location.hash.substring(1);
      if (anchor.startsWith('kupon-') || anchor.startsWith('comment-')) {
        if (anchor.substring(0, 6) === 'kupon-') {
          axios
              .post(this.WP.ajaxUrl, {
                endpoint: 'api_get_coupons',
                coupon_id: Number(anchor.substring(anchor.indexOf('-') + 1))
              })
              .then(response => {
                this.coupon = response.data.data[0];
                this.isCouponModalOpen = true;
              });
        }
        let id = Number(anchor.substring(anchor.indexOf('-') + 1));
        let element = document.getElementById(anchor);
        if (!element) {
          this.commentsMap.forEach(value => {
            if (value.$.type.name !== 'BetItem') {
              return;
            }
            let comment2ndLevel = value.data.answers.find(comment => Number(comment.comment_id) === id);
            if (comment2ndLevel) {
              element = document.getElementById(`comment-${comment2ndLevel.parent_id}`);
              return;
            }
            value.data.answers.find(val => {
              let comment3rdLevel = val.answers.find(comment => Number(comment.comment_id) === id);
              if (comment3rdLevel) {
                element = document.getElementById(`comment-${value.data.comment_id}`);
                return true;
              }
            });
          });
        }
        let betComponent = this.commentsMap.get(id);
        if (betComponent) {
          betComponent.data.showNewBetShadow = true;
          betComponent.ifHasJustBeenAdded();
        }
        let headerHeight = 87;
        if (window.PHP.visibleAdminBar) {
          headerHeight += 32;
        }
        if (element) {
          this.scrollToSmoothly(element.getBoundingClientRect().top + window.pageYOffset - headerHeight, 100);
        }
        let urlWithoutHash = window.location.href.substring(0, window.location.href.indexOf('#'));
        window.history.replaceState(null, '', urlWithoutHash);
      }
    },
    addWSListeners() {
      socket?.on('new-bet', data => {
        if (data.post_id !== this.WP.id) {
          return;
        }
        if (data.comment_approved) {
          if (this.settingsStore.soundNotifications && this.settingsStore.userNotifications.addedNewBet) {
            const audio = new Audio('/wp-content/themes/zawodtyper/assets/audio/5_new.mp3');
            audio.volume = 0.6;
            audio.play().then().catch();
        }

          data.showNewBetShadow = true;
          this.notificationBets = this.notificationBets.concat(data);
          this.betStore.newBetsCount = this.notificationBets.length;
          let index = this.disciplines.findIndex(discipline => {
            return discipline.title === data.discipline;
          });
          if (index !== -1) {
            this.disciplines[index].count++;
          } else {
            this.otherDisciplinesCount++;
          }
        }
      });
      socket?.on('new-bet-discussion', data => {
        if (data.post_id !== this.WP.id) {
          return;
        }
        if (data.comment_approved) {
          if (this.settingsStore.soundNotifications && this.settingsStore.userNotifications.addedNewBet) {
            const audio = new Audio('/wp-content/themes/zawodtyper/assets/audio/5_new.mp3');
            audio.volume = 0.6;
            audio.play().then().catch();
        }

          data.showNewBetDiscussionShadow = true;
          this.notificationBetDiscussions = this.notificationBetDiscussions.concat(data);
          this.betStore.newBetDiscussionsCount = this.notificationBetDiscussions.length;
        }
      });
      socket?.on('adding-bet-add', async data => {
        if (data.postId !== this.WP.id) {
          return;
        }

        data.timestamp = this.DateTime.now().toMillis();
        if (data.userId !== this.WP.user.id) {
          let index = this.currentlyAddingBetUsers.findIndex(user => user.userId === data.userId);
          if (index > -1) {
            this.currentlyAddingBetUsers[index].timestamp = this.DateTime.now().toMillis();
          } else {
            this.currentlyAddingBetUsers.push(data);
          }
        } else {
          let index = this.currentlyAddingBetUsers.findIndex(user => user.userId === data.userId);
          if (this.DateTime.now().toMillis() - this.currentlyAddingBetUsers[index]?.timestamp < 1000) {
            this.userAddingOnAnotherPage = true;
          }
        }
      });
      socket?.on('adding-bet-remove', data => {
        if (data.postId !== this.WP.id) {
          return;
        }
        let index = this.currentlyAddingBetUsers.findIndex(user => user.userId === data.userId);
        if (index > -1) {
          if (this.userAddingOnAnotherPage) {
            this.userAddingOnAnotherPage = false;
          } else {
            this.currentlyAddingBetUsers.splice(index, 1);
          }
        }
        if (data.userId === this.WP.user.id) {
          this.userAddingOnAnotherPage = false;
        }
      });
      socket?.on('adding-bet-discussion-add', async data => {
        if (data.postId !== this.WP.id) {
          return;
        }

        data.timestamp = this.DateTime.now().toMillis();
        if (data.userId !== this.WP.user.id) {
          let index = this.currentlyAddingBetDiscussionUsers.findIndex(user => user.userId === data.userId);
          if (index > -1) {
            this.currentlyAddingBetDiscussionUsers[index].timestamp = this.DateTime.now().toMillis();
          } else {
            this.currentlyAddingBetDiscussionUsers.push(data);
          }
        } else {
          let index = this.currentlyAddingBetDiscussionUsers.findIndex(user => user.userId === data.userId);
          if (this.DateTime.now().toMillis() - this.currentlyAddingBetDiscussionUsers[index]?.timestamp < 1000) {
            this.userAddingOnAnotherPage = true;
          }
        }
      });
      socket?.on('adding-bet-discussion-remove', data => {
        if (data.postId !== this.WP.id) {
          return;
        }
        let index = this.currentlyAddingBetDiscussionUsers.findIndex(user => user.userId === data.userId);
        if (index > -1) {
          if (this.userAddingOnAnotherPage) {
            this.userAddingOnAnotherPage = false;
          } else {
            this.currentlyAddingBetDiscussionUsers.splice(index, 1);
          }
        }
        if (data.userId === this.WP.user.id) {
          this.userAddingOnAnotherPage = false;
        }
      });
    },
    getRefs(commentId) {
      return el => {
        this.commentsMap.set(Number(commentId), el);
      }
    },
    getBlockedUsersIds() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_get_blocked_users_ids'
        })
        .then(response => {
          this.blockedUserIds = response.data.data;
        });
    },
    getBlockingUsersIds() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_get_blocking_users_ids'
        })
        .then(response => {
          this.blockingUserIds = response.data.data;
        });
    },
    getWarnedUsersIds() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_get_warned_users_ids'
        })
        .then(response => {
          this.warnedUserIds = response.data.data;
        });
    },
    getCurrentlyAddingBetText() {
      let usersCount = this.currentlyAddingBetUsers.length;
      return `<span><b>${usersCount} ${this.inflectNumber(usersCount, ['osoba', 'osoby', 'osób'])} </b><span>w trakcie pisania analizy</span></span`;
    },
    getCurrentlyAddingBetDiscussionText() {
      let usersCount = this.currentlyAddingBetDiscussionUsers.length;
      return `<span><b>${usersCount} ${this.inflectNumber(usersCount, ['osoba', 'osoby', 'osób'])} </b><span>w trakcie pisania wpisu dyskusyjnego</span></span`;
    },
    removeElapsedAddingBetUsers() {
      if (this.currentlyAddingBetUsers.length > 0) {
        this.currentlyAddingBetUsers = this.currentlyAddingBetUsers.filter(user => user.timestamp + 120000 > this.DateTime.now().toMillis());
      }
    },
    calculateBetCountByCategory() {
      let sum = 0;
      let filteredBets = [];
      if (!this.showOnlyFollowedUsers && !this.showOnlyNotPlayedYet) {
        filteredBets = this.bets.slice();
      } else {
        filteredBets = this.filteredBets !== null ? this.filteredBets.slice() : this.bets.slice();
      }
      filteredBets = filteredBets.filter(item => {
        return (
            item.comment_type !== 'advert' && !item.comment_type.startsWith('bet_ad_') &&
            (item.rate === null || (Number(item.rate) >= Number(this.odds.min) && Number(item.rate) <= (Number(this.odds.max) === 5.0 ? 999 : Number(this.odds.max))))
        );
      });
      this.disciplines.forEach(x => {
        x.count = 0;
        filteredBets.forEach(bet => {
          if (bet.discipline === x.title) {
            x.count++;
          }
        });
        sum += x.count;
      });
      this.disciplines[this.disciplines.length - 1].count = filteredBets.length - sum;
      let count = 0;
      if (this.disciplineAllSelected) {
        this.filteredBetsCount = this.filteredBetCount;
      } else {
        this.disciplines.forEach((el) => {
          if (el.search) count += el.count;
        });
        this.filteredBetsCount = count;
      }
    },
    openAddBetModal(isAddBetDiscussion = false) {
      if (isAddBetDiscussion) {
        this.isBetDiscussion = true;
      }
      this.isOpenForm = true;
    },
    closeAddBetModal() {
      if (this.isBetDiscussion) {
        this.isBetDiscussion = false;
      }
      this.isOpenForm = false;
    },
    betAddedByUser(bet) {
      if (bet && bet.post_id === this.WP.id) {
        if (bet.comment_type === 'betDiscussion') {
          this.betDiscussions.push(bet);
          this.sortBetDiscussions();
        } else {
          this.bets.push(bet);
          this.sortBets();
        }
        this.$nextTick(() => {
          const newBet = document.getElementById(`comment-${bet.comment_id}`);
          newBet?.scrollIntoView({ behavior: 'smooth', 'inline': 'start'});
        });
      }
    },
    searchTimeout() {
      if (this.searchInputTimeout) {
        clearTimeout(this.searchInputTimeout)
      }
      this.searchInputTimeout = setTimeout(() => {
        this.searchInputTemp = this.searchInput;
        axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_save_phrase',
          type: 'td_search',
          phrase: this.searchInput,
        })
      }, 700)
    },
    confirmSearch(event) {
      if (this.searchInputTimeout) {
        clearTimeout(this.searchInputTimeout)
      }
      this.searchInputTemp = this.searchInput;
      this.searchInputFocus = false;
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_save_phrase',
          type: 'td_search',
          phrase: this.searchInput,
        })
      event.target.blur();
    },
    closeSearch(event) {
      this.searchInput = '';
      this.searchInputTemp = '';
      this.searchInputFocus = false;
      event.target.blur();
    },
    toggleFilter() {
      this.filteringMenuOpened = !this.filteringMenuOpened;
      if (this.filteringMenuOpened) {
        if (window.innerHeight < 1000 && window.size.desktop) {
          this.scrollToSmoothly(200,100)
        }
        this.blockScrolling();
      } else {
        this.unblockScrolling();
      }
    },
    toggleSort() {
      this.sortingMenuOpened = !this.sortingMenuOpened;
      if (this.sortingMenuOpened) {
        this.blockScrolling();
      } else {
        this.unblockScrolling();
      }
    },
    toggleBetDiscussionSort() {
      this.sortingBetDiscussionMenuOpened = !this.sortingBetDiscussionMenuOpened;
      if (this.sortingBetDiscussionMenuOpened) {
        this.blockScrolling();
      } else {
        this.unblockScrolling();
      }
    },
    getBonusAdvertisement(ad) {
      axios.get('/wp-json/acf/v3/options/options?_fields=acf.limited_time_bonuses&acf_format=standard').then(response => {
        this.limitedTimeBonuses = response.data.acf.limited_time_bonuses;
        if (this.limitedTimeBonuses.length > 0) {
          this.limitedTimeBonuses.sort((a, b) => {
            const endA = DateTime.fromSQL(a.limited_time_bonus.bonus_end_time).toMillis();
            const endB = DateTime.fromSQL(b.limited_time_bonus.bonus_end_time).toMillis();
            if (endA < Date.now() && endB < Date.now()) {
              return 0;
            } else if (endA < Date.now()) {
              return 1;
            } else if (endB < Date.now()) {
              return -1;
            }
            return endA - endB;
          });
          this.limitedTimeBonuses = this.limitedTimeBonuses.filter(a => {
            const endDateTime = DateTime.fromSQL(a.limited_time_bonus.bonus_end_time).toMillis();
            const threeHoursAgoMillis = DateTime.now().toMillis() - 3 * 60 * 60 * 1000;
            return endDateTime > threeHoursAgoMillis;
          });
          ad.limitedTimeBonuses = this.limitedTimeBonuses;
          if (this.limitedTimeBonuses.length === 0) {
            this.removeAdByType('bonuses');
          }
          return;
        }
        this.removeAdByType('bonuses');
      });
    },
    getAds() {
      axios
        .post(this.WP.ajaxUrl, {
          endpoint: 'api_get_td_ads',
        })
        .then(response => {
          this.ads = response.data.data ?? [];
          this.ads.forEach(ad => {
            if (this.adsDetails.length === 0) {
              this.adsDetails.push({
                type: ad.comment_type,
                maxShowCount: Number(ad.max_show_count),
                showGap: Number(ad.show_gap),
                shownCount: 0,
              });
            } else {
              let index = this.adsDetails.findIndex(e => e.type === ad.comment_type);
              if (index === -1) {
                this.adsDetails.push({
                  type: ad.comment_type,
                  maxShowCount: Number(ad.max_show_count),
                  showGap: Number(ad.show_gap),
                  shownCount: 0,
                });
              }
            }
            if (ad.comment_type === 'bonuses') {
              this.getBonusAdvertisement(ad);
            }
          });
        });
    },
    getAdShowGap(type) {
      return this.adsDetails.find(e => {
        return e.type === type;
      })?.showGap;
    },
    getAdMaxShowCount(type) {
      return this.adsDetails.find(e => {
        return e.type === type;
      })?.maxShowCount;
    },
    getAdShownCount(type) {
      return this.adsDetails.find(e => {
        return e.type === type;
      })?.shownCount;
    },
    resetShownAddCount() {
      this.adsDetails.forEach(adDetail => {
        adDetail.shownCount = 0;
      })
    },
    incrementAdShownCount(type) {
      let index = this.adsDetails.findIndex(e => {
        return e.type === type;
      });
      if (index !== -1) {
        this.adsDetails[index].shownCount++;
      }
    },
    checkAdToAdGap(lastAddIndex, index) {
      return index - lastAddIndex > this.adsMinGap;
    },
    checkToAddAdvertType(lastShownAdIndex, i, type) {
      let adToAdGap = this.checkAdToAdGap(lastShownAdIndex, i + 1);
      let isAdLimitReached = this.getAdShownCount(type) < this.getAdMaxShowCount(type);
      return ((i + 1) % this.getAdShowGap(type) === 0 && isAdLimitReached && adToAdGap) ||
          ((i + 1) > (this.getAdShowGap(type) + this.getAdShowGap(type) * this.getAdShownCount(type)) && isAdLimitReached && adToAdGap);
    },
    addSingleAd(type, i, arr) {
      let index = this.ads.findIndex(ad => {
        return ad.comment_type === type;
      });
      if (index !== -1) {
        this.ads[index].comment_id = 10000000 + i;
        arr.push(this.ads[index]);
        this.incrementAdShownCount(type);
      }
    },
    addReapetedAd(type, i, arr){
      let counter = this.getAdShownCount(type);
      while (this.ads[counter % this.ads.length].comment_type !== type) {
        counter++;
      }
      let ad = structuredClone(toRaw(this.ads[counter % this.ads.length]));
      ad.comment_id = 10000000 + i;
      arr.push(ad);
      this.incrementAdShownCount(type);
    },
    removeAdByType(adTypeToRemove) {
      const indexToRemove = this.adsDetails.findIndex(ad => ad.type === adTypeToRemove);

      if (indexToRemove !== -1) {
        this.adsDetails.splice(indexToRemove, 1);
      }
    },
    changeBetDay(bet_id){
      let index = this.bets.findIndex(bet => {
          return Number(bet.comment_id) === bet_id;
      });
      this.bets.splice(index, 1);
      this.filterBets(true);
    },
    editBetIncrement() {
      this.betEdited += 1;
    }
  }
};
</script>

<style scoped>
input::-webkit-calendar-picker-indicator {
  opacity: 0;
}

.slide-form-enter-active,
.slide-form-leave-active {
  transition: all 0.5s ease-out;
  max-height: 800px;
  padding-bottom: 1.25rem;
}

.slide-form-enter-from,
.slide-form-leave-to {
  max-height: 0;
  padding-bottom: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 0.3s ease-out;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.fade-move{
  transition: all .7s ease-in-out;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus,
input:autofill,
input:autofill:hover,
input:autofill:focus {
  border: 1px solid #FFFFFF80;
  color: #FFF;
  caret-color: #FFF;
  -webkit-text-fill-color: #FFF;
  -webkit-box-shadow: 0 0 0px 1000px #272c3e inset;
  transition: background-color 5000s ease-in-out 0s;
}
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
  appearance: textfield;
}

.course input[type='text'] {
  border: none;
  outline: none;
  cursor: default;
  text-align: center;
  max-width: 80px;
}
.x-icon {
  margin-left: 4px;
}
/* Poppover */
:deep(.popper) {
  background: gray;
  padding: 10px;
  border-radius: 5px;
  color: #fff;
}
:deep(.popper #arrow::before),
:deep(.popper:hover),
:deep(.popper:hover > #arrow::before) {
  background: gray;
}

.sort-item {
  @apply relative py-4 px-5 border-b border-zt-light flex flex-col justify-start cursor-pointer
  last:border-b-0 first:rounded-t-zt last:rounded-b-zt
  hover:bg-zt-light;
}

.sort-item:before {
  @apply content-[''] w-[3px] left-0 top-1/2 -translate-y-1/2 h-[70%] absolute rounded-zt;
}

.sort-modal:after {
  @apply content-[''] absolute -top-[16px] right-[24px] w-0 h-0 border-b-zt-normal border-b-[16px] border-x-transparent border-x-[8px];
}
.caret:after {
  @apply content-[''] absolute -top-[16px] left-[36px] w-0 h-0 border-b-zt-normal border-b-[16px] border-x-transparent border-x-[8px];
}

.form-switch .form-check-input {
  margin-top: 0.1rem;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-3.5 -3.5 7 7'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e");
  background-position: left center;
  -webkit-transition: background-position 0.3s ease-in-out;
  transition: background-position 0.3s ease-in-out;
}
.form-switch .form-check-input:focus {
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-3.5 -3.5 7 7'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e");
}
.form-switch .form-check-input:checked {
  background-position: right center;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-3.5 -3.5 7 7'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e");
}
.scrollbar-hidden::-webkit-scrollbar {
    display: none;
}

/* Hide scrollbar for IE, Edge add Firefox */
.scrollbar-hidden {
    -ms-overflow-style: none;
    scrollbar-width: none; /* Firefox */
}
</style>